/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Patient Events View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PatientEventsView';

export const mapStateToPropsPatientEvents = mapStateToProps;
export const mapDispatchToPropsPatientEvents = mapDispatchToProps;

export default connect(
  mapStateToPropsPatientEvents,
  mapDispatchToPropsPatientEvents
)(View);
